import {
  uploadMedia,
  getBase64,
  setAzureStorageToken,
  download,
  getImageSrc
} from './mediaSDK.js'

export default {
  uploadMedia,
  getBase64,
  setAzureStorageToken,
  download,
  getImageSrc,
}
